import React from "react";
import { IconProps, getSocialIconColor } from "../SocialIcon";

export const Facebook: React.FC<IconProps> = (props) => {
  const fill = getSocialIconColor({
    ...props,
    colorFill: "#3b5998"
  });

  return (
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
      width="96px" height="96px" viewBox="0 0 96 96">
      <title>Facebook</title>
      <path id="Facebook-2" fill={fill} d="M96,90.7c0,2.9-2.4,5.3-5.3,5.3l0,0H66.2V58.8h12.5l1.9-14.5H66.2v-9.2c0-4.2,1.2-7,7.2-7h7.7
        V15c-3.7-0.4-7.4-0.6-11.2-0.6c-11,0-18.6,6.8-18.6,19.2v10.7H38.8v14.5h12.5V96h-46C2.4,96,0,93.6,0,90.7l0,0V5.3
        C0,2.4,2.4,0,5.3,0l0,0h85.4C93.6,0,96,2.4,96,5.3l0,0V90.7z"/>
    </svg>
  )
}
